import { getCategoryId } from "../../../state/modules/category/selectors";
import { getPageName } from "../../../state/modules/page/selectors";
import { getSearchTerm } from "../../../state/modules/search/domains/query/selectors";
import {
  SEARCH_PAGE,
  CATEGORY_PAGE,
  BRANDS_PAGE,
  BRAND_ERROR,
  BRAND_UNAVAILABLE,
} from "../../../state/modules/page/constants";

export const getPageMetadata = (state) => {
  const pageName = getPageName(state);

  if (pageName === SEARCH_PAGE) {
    const searchTerm = getSearchTerm(state);

    return {
      analyticsPageId: `successful search: ${searchTerm}`,
      analyticsPageType: "successful search",
    };
  }

  if (pageName === CATEGORY_PAGE) {
    const categoryId = getCategoryId(state);

    return {
      analyticsPageId: `category page: ${categoryId}`,
      analyticsPageType: "category page",
    };
  }

  if (pageName === BRANDS_PAGE) {
    return {
      analyticsPageId: "a to z of brands",
      analyticsPageType: "category page",
    };
  }

  if (pageName === BRAND_ERROR || pageName === BRAND_UNAVAILABLE) {
    return {
      analyticsPageId: "failed search",
      analyticsPageType: "failed search",
    };
  }

  return {};
};
